export default {
    url: '',
    template: '<user-budget-list/>',
    controller () {
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/user/budget/list/index.js